import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { FAQSchema } from "./SEOSchema";
import { SERVICE_TERMS } from "../data/serviceTerms";

export const FAQ_ITEMS = [
  {
    q: "Livrez-vous vraiment 24h/24 et 7 jours sur 7 ?",
    a: SERVICE_TERMS.hoursAnswer,
  },
  {
    q: "Quelle est la zone de livraison exacte ?",
    a: "Nous livrons toute la Côte d'Azur entre Cannes et Monaco : Cannes, Antibes, Juan-les-Pins, Cagnes-sur-Mer, Nice, Villefranche-sur-Mer, Beaulieu-sur-Mer, Saint-Jean-Cap-Ferrat, Èze, Cap-d'Ail et la Principauté de Monaco. Hors zone, appelez-nous, nous regardons ensemble.",
  },
  {
    q: "En combien de temps êtes-vous chez moi ?",
    a: "Le délai dépend de votre ville et de la circulation : généralement 20 à 40 minutes, et 35 à 45 minutes à Monaco. Nous vous confirmons le délai lors de la commande.",
  },
  {
    q: "Comment passer commande ?",
    a: "Trois moyens : par téléphone au 06 23 06 03 08, par WhatsApp au même numéro, ou depuis notre site noctua-riviera.com. L'appel reste le moyen le plus rapide, surtout la nuit.",
  },
  {
    q: "Quels moyens de paiement acceptez-vous ?",
    a: SERVICE_TERMS.paymentAnswer,
  },
  {
    q: "Livrez-vous de l'alcool et du tabac la nuit ?",
    a: "Oui, mais la vente est strictement réservée aux personnes majeures (18 ans et plus). Une pièce d'identité peut être demandée à la livraison. L'abus d'alcool est dangereux pour la santé.",
  },
  {
    q: "Livrez-vous à bord d'un yacht ou dans un hôtel ?",
    a: "Absolument. Nous livrons régulièrement dans les hôtels 3 à 5 étoiles de la Riviera ainsi que sur les ports et yachts (Port Hercule, Port de Nice, Port de Cannes, Port Vauban à Antibes…). Précisez le port et le nom du bateau au moment de la commande.",
  },
  {
    q: "Y a-t-il un minimum de commande ?",
    a: SERVICE_TERMS.minimumAnswer,
  },
];

export const FAQSection = () => {
  const [open, setOpen] = useState(0);

  return (
    <section
      className="py-24 sm:py-32 bg-[#0a0f1a]"
      data-testid="faq-section"
      id="faq"
    >
      <FAQSchema items={FAQ_ITEMS} />
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div className="mb-14 text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-3">
            Questions fréquentes
          </p>
          <h2 className="font-display text-4xl sm:text-5xl leading-none">
            Ce que vous <span className="italic text-[#d4af37]">devez savoir</span>
          </h2>
        </div>
        <div className="divide-y divide-white/8 border-y border-white/8">
          {FAQ_ITEMS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                  aria-expanded={isOpen}
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="font-display text-lg sm:text-xl text-white group-hover:text-[#d4af37] transition-colors">
                    {item.q}
                  </span>
                  <ChevronDown
                    size={20}
                    className={`shrink-0 text-[#d4af37] transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? "max-h-96 pb-6" : "max-h-0"
                  }`}
                >
                  <p className="text-gray-300 leading-relaxed text-[15px] max-w-3xl" data-testid={`faq-answer-${i}`}>
                    {item.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
